const actions = {
    REPORT_SET_COLUMNS: 'REPORT_SET_COLUMNS',
    REPORT_READ_REQUEST: 'REPORT_READ_REQUEST',
    REPORT_READ_SUCCESS: 'REPORT_READ_SUCCESS',
    REPORT_READ_FAILURE: 'REPORT_READ_FAILURE',
    REPORT_READ_CUSTOM_FIELDS_REQUEST: 'REPORT_READ_CUSTOM_FIELDS_REQUEST',
    REPORT_READ_CUSTOM_FIELDS_SUCCESS: 'REPORT_READ_CUSTOM_FIELDS_SUCCESS',
    REPORT_READ_CUSTOM_FIELDS_ERROR: 'REPORT_READ_CUSTOM_FIELDS_ERROR',
    REPORT_EXPORT_REQUEST: 'REPORT_EXPORT_REQUEST',
    REPORT_EXPORT_SUCCESS: 'REPORT_EXPORT_SUCCESS',
    REPORT_EXPORT_ERROR: 'REPORT_EXPORT_ERROR',
    REPORT_RESET_STATE: 'REPORT_RESET_STATE',
    REPORT_SET_FILTER_STATE: 'REPORT_SET_FILTER_STATE',

    setColumns: columns => ({
        type: actions.REPORT_SET_COLUMNS,
        columns,
    }),
    readReport: (reportType, request) => ({
        type: actions.REPORT_READ_REQUEST,
        reportType,
        request,
    }),
    readReportCustomFields: request => ({
        type: actions.REPORT_READ_CUSTOM_FIELDS_REQUEST,
        request, // {date_from, date_to, type, tag_ids[], field_ids[],}
    }),
    exportReport: (reportType, format, request, label) => ({
        type: actions.REPORT_EXPORT_REQUEST,
        reportType, // eg: 'transaction_list'
        format, // 'xls' or 'pdf
        request,
        label,
    }),
    setFilterState: filterState => ({
        type: actions.REPORT_SET_FILTER_STATE,
        filterState,
    }),
    resetState: () => ({
        type: actions.REPORT_RESET_STATE,
    }),
};
export default actions;
